const BASE_PREFIX = process.env.VUE_APP_BASEURL;
const serverConfig = {
  baseURL: BASE_PREFIX, // 请求基础地址,可根据环境自定义
  useTokenAuthorization: false, // 是否开启 token 认证
};
// console.log("BASE_PREFIX", BASE_PREFIX);
export default serverConfig;
